import { jsxs, jsx } from "react/jsx-runtime";
const IllustrationLockedSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 64,
    height: 64,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30 60C13.484 60 0 46.516 0 30S13.484 0 30 0s30 13.484 30 30-13.484 30-30 30Zm0-55.372C16.037 4.628 4.628 16.038 4.628 30c0 13.963 11.33 25.372 25.372 25.372 13.963 0 25.372-11.33 25.372-25.372C55.292 16.037 43.962 4.628 30 4.628Z",
            fill: "#D6D6D6"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30 1.436c15.718 0 28.564 12.846 28.564 28.564S45.718 58.564 30 58.564 1.436 45.718 1.436 30C1.436 14.202 14.202 1.436 30 1.436ZM30 0C13.484 0 0 13.484 0 30s13.484 30 30 30 30-13.484 30-30S46.516 0 30 0Z",
            fill: "#999"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M37.26 25.612h-1.675v-2.394c0-3.112-2.553-5.665-5.665-5.665-3.111 0-5.665 2.553-5.665 5.665v2.394H22.58a.715.715 0 0 0-.718.718v12.287c0 .399.319.718.718.718h14.6a.715.715 0 0 0 .718-.718V26.33c.08-.4-.24-.718-.638-.718Zm-6.302 7.1v1.676c0 .559-.48.958-.958.958-.558 0-.957-.479-.957-.958v-1.675c-.718-.32-1.197-1.117-1.197-1.995 0-1.197.957-2.154 2.154-2.154s2.154.957 2.154 2.154c0 .958-.478 1.676-1.196 1.995Zm1.915-7.1h-5.825v-2.394a2.86 2.86 0 0 1 2.872-2.872 2.86 2.86 0 0 1 2.873 2.872v2.394h.08Z",
            fill: "#000"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h60v60H0z" }) }) })
    ]
  }
);
export {
  IllustrationLockedSvg
};
